import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Wrench, FileText } from "lucide-react";
import { ServicesListView } from "./Services/ServicesListView";
import { ServiceOrdersListView } from "./ServiceOrders/ServiceOrdersListView";

export function ServicesMainView() {
  return (
    <div className="space-y-6 p-6">
      <div>
        <h1 className="text-3xl font-bold tracking-tight">Serviços</h1>
        <p className="text-muted-foreground">
          Gestão de serviços e ordens de serviço
        </p>
      </div>

      <Tabs defaultValue="orders" className="space-y-6">
        <TabsList>
          <TabsTrigger value="orders">
            <FileText className="h-4 w-4 mr-2" />
            Ordens de Serviço
          </TabsTrigger>
          <TabsTrigger value="services">
            <Wrench className="h-4 w-4 mr-2" />
            Cadastro de Serviços
          </TabsTrigger>
        </TabsList>

        <TabsContent value="orders" className="space-y-6">
          <ServiceOrdersListView />
        </TabsContent>

        <TabsContent value="services" className="space-y-6">
          <ServicesListView />
        </TabsContent>
      </Tabs>
    </div>
  );
}
